import React, { useEffect, useState } from "react"
import Modal from "./Modal"
import Button from "./Button"
import { Trans } from "react-i18next"
import { t } from "i18next"

function ForceUserLocationModal({
  isOpen,
  onGetLocation,
}: {
  isOpen: boolean
  onGetLocation: () => void
}) {
  const [deviceType, setDeviceType] = useState<string>("general")

  useEffect(() => {
    setDeviceType(detectDeviceAndBrowser())
  }, [])

  return (
    <Modal isOpen={isOpen}>
      <div>
        <h2 style={{ marginBottom: "2.2rem" }}>{t("userLocation.sharePosition")}</h2>
        <p style={{ marginBottom: "1rem" }}>
          <Trans i18nKey="userLocation.sharePositionInfo" />
        </p>
        <div style={{ marginBottom: "2.4rem" }}>
          <Trans i18nKey={getInstructionsKey(deviceType)} />
        </div>
        <Button text={t("userLocation.getLocation")} onClick={onGetLocation} />
      </div>
    </Modal>
  )
}

export default ForceUserLocationModal
function getInstructionsKey(deviceType: string): string {
  switch (deviceType) {
    case "iOS":
      return "userLocation.instructionsiOS"
    case "Android":
      return "userLocation.instructionsAndroid"
    case "Chrome":
      return "userLocation.instructionsChrome"
    case "Safari":
      return "userLocation.instructionsSafari"
    case "Firefox":
      return "userLocation.instructionsFirefox"
    case "Edge":
      return "userLocation.instructionsEdge"
    default:
      return "userLocation.instructionsGeneral"
  }
}

function detectDeviceAndBrowser() {
  const userAgent = navigator.userAgent.toLowerCase()
  console.log(userAgent)
  // iOS detection
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "iOS"
  }

  // Android detection
  if (/android/.test(userAgent)) {
    return "Android"
  }

  // Browser detection for desktop
  if (/chrome/.test(userAgent) && !/edge|edg/.test(userAgent)) {
    return "Chrome"
  }

  if (/firefox/.test(userAgent)) {
    return "Firefox"
  }

  if (/safari/.test(userAgent) && !/chrome|chromium|crios/.test(userAgent)) {
    return "Safari"
  }

  if (/edge|edg/.test(userAgent)) {
    return "Edge"
  }

  // Default fallback
  return "general"
}
